
import countries from './_locales.json'
import { reduce } from 'vessel/utils'

const locales = reduce(countries, (result, code, languages) => {
  for (const lang of languages.split(' ')) {
    result[lang] = code
  }
})

const country = value => {
  if (!value || !value.match(/^(\w{2,3}[-_])?\w{2,3}$/)) {
    return 'UN'
  }

  const data = value.toUpperCase().split(/-|_/)
  const lang = data.shift()
  const code = data.pop()

  if (countries[lang]) return lang
  if (countries[code]) return code

  return locales[lang] || value
}

const flag = code => {
  const a = String.fromCodePoint(code.codePointAt(0) - 0x41 + 0x1F1E6)
  const b = String.fromCodePoint(code.codePointAt(1) - 0x41 + 0x1F1E6)

  return a + b
}

export default {
  name: 'VsFlag',
  inheritAttrs: false,
  props: {
    code: {
      type: String,
      required: true
    }
  },
  computed: {
    flag() {
      return flag(country(this.code))
    }
  }
}
